<div class="feature">
  <img
    alt=""
    src="assets/img/channels/tick.svg"
    class="tick-icon"
  >
  <p class="feature-text">{{textKey | translate}}</p>
</div>
